import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";

/**
 * Mahano wordmark — the real "Mahano OS" lettering, ink on light surfaces and
 * ivory on dark. Pass `lockup` to get the full mark + wordmark + tagline asset.
 * Filename kept so every existing import keeps working.
 */
export default function HaloWordmark({
  className = "",
  height = 20,
  lockup = false,
  tone,            // "light" | "dark" — force a surface tone (ink panels, etc.)
  alt = "Mahano OS",
  ...rest
}) {
  const { theme } = useTheme();
  const surface = (tone || theme) === "dark" ? "on-dark" : "on-light";
  const src = `/brand/${lockup ? "lockup" : "wordmark"}-${surface}.png`;
  const aspect = lockup ? 1896 / 415 : 1270 / 202;
  return (
    <img
      src={src}
      alt={alt}
      draggable="false"
      className={cn("select-none object-contain", className)}
      style={{ height, width: height * aspect }}
      {...rest}
    />
  );
}
